import 'iview/dist/styles/iview.css'

import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import App from '@/components/app'
import iView from 'iview'
import router from './router'

import actions from './store/actions'
import getters from './store/getters'
import mutations from './store/mutations'
import state from './store/state'

Vue.use(iView)
Vue.use(Vuex)

Vue.config.productionTip = false
const debug = false

var store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})

iView.LoadingBar.config({
  color: '#5cb85c',
  failedColor: '#f0ad4e',
  height: 2
});

router.beforeEach((to, from, next) => {
  store.commit('setActiveMenu', to.name)
  iView.LoadingBar.start()
  next()
})

router.afterEach(route => {
  iView.LoadingBar.finish()
})

Vue.prototype.showSuccess = function (msg) {
  this.$Notice.success({
    title: '提示',
    desc: msg
  })
}

Vue.prototype.showErr = function (err) {
  let errMsg = err
  if (typeof (err) === 'object' && err.execute_err) {
    errMsg = err.execute_err
  }
  if (errMsg === 'contract check failed') {
    errMsg = '检测mainnet网络失败，请切换浏览器钱包到主网！'
  }
  this.$Notice.error({
    title: '提示',
    desc: errMsg
  })
}

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js